import { render, staticRenderFns } from "./CommonApprovalRecords.vue?vue&type=template&id=29180b62&scoped=true"
import script from "./CommonApprovalRecords.vue?vue&type=script&lang=js"
export * from "./CommonApprovalRecords.vue?vue&type=script&lang=js"
import style0 from "./CommonApprovalRecords.vue?vue&type=style&index=0&id=29180b62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29180b62",
  null
  
)

export default component.exports